module.exports = __webpack_public_path__ + "static/media/spettacollo.61be5496.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/spettacollo.mp3
// module id = 190
// module chunks = 0